import {DotLottieReact} from '@lottiefiles/dotlottie-react'

import spinnerLottie from '@/assets/lotties/spinner.lottie'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './Loading.module.scss'

export default memo(function Loading({label = 'Loading...'}: {label?: string}) {
  return (
    <div className={style.SpinnerContainer} role='alert'>
      <DotLottieReact
        src={spinnerLottie}
        autoplay
        loop
        className={style.Spinner}
        aria-label={label}
        role='progressbar'
      />
      <VisuallyHidden>{label}</VisuallyHidden>
    </div>
  )
})
